// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"00242833","455":"551b4d4c"}[chunkId] + ".chunk.js";
};